import {Component, Input} from '@angular/core';

@Component({
  selector: 'cl-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent {

  @Input()
  dialog;

  @Input()
  title;

  @Input()
  closeAriaLabel = 'Zamknij okno dialogowe';

  close() {
    this.dialog.close();
  }

}
